import React from "react";
import {fromCamelCaseToTitle} from "../Utility";

const OrderInternalLog = ({ logDetail }) => {
    if (!logDetail) return null;

    // Split log by "|"
    const parts = logDetail.split("|").map(p => p.trim());
    const [date = "", updatedBy = "", items = ""] = parts;

    // Format updatedBy
    const updatedByName = updatedBy?.replace(/updatedBy:/i, "").trim();

    // Split items by "," and reverse
    const changes = items.split(",").map(c => c.trim()).reverse();

    return (
        <div className="bg-warning mb-2 fs-md text-black p-3 bg-opacity-25 rounded-2">
            <div className="d-flex justify-content-between mb-1">
                <p className="mb-0">
                    Updated by: <span className="fw-semibold text-body">{fromCamelCaseToTitle(updatedByName)}</span>
                </p>
                <p className="mb-0 fw-semibold text-body">{date}</p>
            </div>
            <ul className="mb-0 ps-5">
                {changes.map((change, idx) => (
                    <li key={idx}>{change}</li>
                ))}
            </ul>
        </div>
    );
};

export default OrderInternalLog;
